import { render, staticRenderFns } from "./LegendField.vue?vue&type=template&id=daae2ea2&"
import script from "./LegendField.vue?vue&type=script&lang=js&"
export * from "./LegendField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports